<template>
  <router-view />
</template>

<style lang="stylus">
#app
  text-align center
  color #2c3e50
</style>
<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "App",
});
</script>
